import { createAsyncThunk } from "@reduxjs/toolkit";
import apiConfig from "constants/apiConfig";
import { fetchCollaboration, fetchCollaborations } from "services/api/collaboration-legacy";
import { AuthState } from "slices/auth/reducer";
import { ERROR } from "types";
import { CollaborationLegacy, CollaborationLegacySlice } from "types/collaboration-legacy";
import { generateUniqueKey, getErrorMessage, isFresh } from "utils/helpers";

export const fetchLegacyCollaborationsListThunk = createAsyncThunk<{ count: number, items: CollaborationLegacy[], filters: { page: number, [key: string]: any }, filterId: string }, { filters: { page: number, [key: string]: any }, force?: boolean }, { rejectValue: string }>(
    'legacyCollaborations/list',
    async ({ filters, force }, { getState, rejectWithValue }) => {
        try {
            const { page } = filters;
            const STALE_TIME = apiConfig.FETCH_COLLABORATIONS.staleTime;

            const state = getState() as { auth: AuthState, legacyCollaborations: CollaborationLegacySlice }
            const filterId = generateUniqueKey(filters, ['page']);

            if (page === 1 && !force && isFresh(state.legacyCollaborations?.filtered_lists?.[filterId]?.last_fetched_at, STALE_TIME)) {
                return rejectWithValue(ERROR.CACHED);
            }

            const hubId = state.auth.selectedHubId;
            if (!hubId) throw new Error("No hub selected!");

            const { count, items } = await fetchCollaborations(hubId, { ...filters });

            return { count, items, filters, filterId }


        } catch (error) {
            return rejectWithValue(getErrorMessage(error, "Failed to fetch collaboration!"));
        }
    }
)

export const fetchLegacyCollaborationThunk = createAsyncThunk<{campaignId: string, influencerId: string, collaboration: CollaborationLegacy, cache?: boolean}, {campaignId: string, influencerId: string, force?: boolean}, {rejectValue: string}>(
       'legacyCollaboration/fetch',
       async ({campaignId, influencerId, force}, {rejectWithValue, getState}) => {
        try {
            const STALE_TIME = apiConfig.FETCH_COLLABORATION.staleTime;

            const state = getState() as { auth: AuthState, legacyCollaborations: CollaborationLegacySlice }

            const cachedData = state.legacyCollaborations?.items?.[campaignId]?.[influencerId]

            if(!force && isFresh(cachedData?.last_fetched_at, STALE_TIME)){
                return {campaignId, influencerId, collaboration: cachedData.collaboration, cache: true}
            }

            const hubId = state.auth.selectedHubId;
            if (!hubId) throw new Error("No hub selected!");

            const collabData = await fetchCollaboration(hubId, campaignId, influencerId);

            return {campaignId, influencerId, collaboration: collabData};


        } catch (error) {
            return rejectWithValue(getErrorMessage(error, "Failed to fetch collab!"));
        }
       }   
)